import React, { useEffect, useState } from 'react';

import { colors } from 'global/colors';
import { Container, Wrapper } from 'components/Layout/Layout';
import { useActions } from 'hooks/useActions';
import { Images } from 'assets/images';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import CurvedContainer from 'components/CurvedContainer/CurvedContainer';
import ChallengeCard from 'components/ChallengeCard/ChallengeCard';
import SearchBar from 'components/SearchBar/SearchBar';
import Sorting from 'components/Sorting/Sorting';
import Filter from 'components/FilterSidebar/FilterSidebar';
import * as actions from './actions';
import { CardGrid } from 'components/CardContainer/styles';
import { searchQueryFilter, tagFilter } from 'functions/filters';
import { sortFunc } from 'functions/sort';
import PageTitleHeader from 'components/PageTitleHeader/PageTitleHeader';
import {
  HeaderContainer,
  RightHeaderContainer,
  SortByLabel,
  LeftContainer,
  RightContainer,
  ContentContainer,
} from './styles';

export default function CourseListPage() {
  const { getAllCourses, setTagFilters } = useActions(actions);
  const { loading, error, courses, selectedTagFilters } = useSelector((state) => state.CourseListPageReducer);

  useEffect(() => {
    getAllCourses();
  }, [getAllCourses]);

  useEffect(() => {
    if (error) toast.error(error);
  }, [error]);

  const heroImage = Images.tanks;

  const [filterOptions, setFilterOptions] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [items, setItems] = useState(courses.slice());
  const [selectedRating, setSelectedRating] = useState(3);
  const [hasFilters, setHasFilters] = useState(false);
  const [sortBy, setSortBy] = useState({
    value: 'averageRating',
    descendingOrder: true,
  });

  // Filters array when searchQuery, selectedTagFilters, selectedRating or itemsArray changes
  useEffect(() => {
    let filteredItems = courses.filter(searchQueryFilter(searchQuery)).filter(tagFilter(selectedTagFilters));
    setItems(filteredItems);
    setHasFilters(selectedTagFilters.length > 0 || !!selectedRating);
  }, [searchQuery, selectedTagFilters, selectedRating, courses]);

  useEffect(() => {
    if (!courses) return;
    const difficultyTags = ['Easy', 'Medium', 'Hard'];
    let hasDifficultyTags = false;
    let tagItems = new Set();

    for (const course of courses) {
      for (const tag of course.keywords) {
        if (difficultyTags.includes(tag)) {
          hasDifficultyTags = true;
        } else {
          tagItems.add(tag);
        }
      }
    }

    tagItems = Array.from(tagItems).sort();

    let newOptions = [];

    if (tagItems.length) {
      newOptions.push({
        title: 'Tag',
        items: tagItems,
        type: 'keywords',
        selectedKeywords: selectedTagFilters,
        onChange: (selection) => {
          setTagFilters(selection);
        },
      });
    }
    if (hasDifficultyTags) {
      newOptions.push({
        title: 'Difficulty',
        items: difficultyTags,
        type: 'keywords',
        selectedKeywords: selectedTagFilters,
        onChange: (selection) => {
          setTagFilters(selection);
        },
      });
    }
    setFilterOptions(newOptions);
  }, [courses, selectedTagFilters, selectedRating, setTagFilters]);

  const clearFilters = () => {
    setTagFilters([]);
    setSelectedRating(undefined);
  };

  const rootContainer = (
    <Container column>
      <PageTitleHeader type={'courses'} />
      <ContentContainer>
        <LeftContainer>
          <Filter items={items} hasFilters={hasFilters} clearFilters={clearFilters} options={filterOptions} />
        </LeftContainer>
        <RightContainer>
          <HeaderContainer>
            <SearchBar value={searchQuery} onChange={setSearchQuery} />
            <RightHeaderContainer>
              <SortByLabel>Sort by:</SortByLabel>
              <Sorting
                value={sortBy.value}
                descendingOrder={sortBy.descendingOrder}
                options={[
                  { value: 'name', label: 'Name' },
                  { value: 'createdAt', label: 'Newest' },
                ]}
                onChange={(value) => setSortBy(value)}
              />
            </RightHeaderContainer>
          </HeaderContainer>
          {!loading ? (
            <CardGrid minHeight={'290px'}>
              {items
                .sort((a, b) => sortFunc(a, b, sortBy))
                .map((item) => (
                  <ChallengeCard {...item} link={`/courses/${item._id}`} type={'courses'} key={item._id} />
                ))}
            </CardGrid>
          ) : (
            <div>Loading...</div>
          )}
        </RightContainer>
      </ContentContainer>
    </Container>
  );

  return (
    <Wrapper color="transparent">
      <CurvedContainer bottom height={110} color={colors.fsDarkBlue} image={heroImage}></CurvedContainer>
      {rootContainer}
    </Wrapper>
  );
}
